import { ValidationType } from '../utils/validators';

import Field, { FieldDataType } from './Field';
import { Section } from './index';
import { NON_REFUNDABLE_FEES } from '../constants';

/**
 * Class to model People Section data returned by API
 */
export default class NonRefundableFeesSection extends Section {
  constructor(args) {
    super(args);

    this.setIndexedFieldTypes([
      new Field({
        fieldName: NON_REFUNDABLE_FEES.FIELD_NAME.IS_ENABLED,
        dataType: FieldDataType.boolean,
        enteredValue: true,
        validation: ValidationType.BooleanValidator,
      }),
      new Field({
        fieldName: NON_REFUNDABLE_FEES.FIELD_NAME.AMOUNT,
        enteredValue: '',
        dataType: FieldDataType.currency,
        validation: ValidationType.CurrencyValidator,
      }),
      new Field({
        fieldName: NON_REFUNDABLE_FEES.FIELD_NAME.NAME,
        enteredValue: '',
        dataType: FieldDataType.string,
        validation: null,
      }),
    ]);
  }
}
